import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { http, apiError } from "../../lib/api";

const PLAN_OPTS = [["y1", "+1 Year ₹99"], ["trial", "+3 days trial"]];

function MemberRow({ m, auth, reload }) {
  const [plan, setPlan] = useState("y1");
  const act = async (path, body) => {
    try { await http.post(path, body, auth()); toast.success("Updated"); reload(); } catch (e) { toast.error(apiError(e)); }
  };
  const exp = m.plan_expires_at ? new Date(m.plan_expires_at).toLocaleDateString("en-IN") : "—";
  return (
    <div className="p-3 flex flex-wrap items-center gap-3" data-testid={`admin-member-${m.id}`}>
      <div className="flex-1 min-w-[200px]">
        <p className="font-semibold text-[var(--navy)]">{m.name} · +91 {m.mobile}</p>
        <p className="text-xs text-slate-500">{m.taluka}, {m.district} · Plan: {m.plan_id || "none"} · Till {exp} · <b className={m.plan_state === "active" ? "text-green-700" : "text-[var(--sell)]"}>{m.plan_state}</b></p>
      </div>
      <select value={plan} onChange={(e) => setPlan(e.target.value)} className="h-9 rounded-lg border border-slate-300 text-sm px-2" data-testid={`admin-member-plan-select-${m.id}`}>
        {PLAN_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <button onClick={() => act(`/admin/members/${m.id}/plan`, { plan_id: plan })} className="h-9 px-3 rounded-lg bg-green-600 text-white text-sm font-semibold" data-testid={`admin-member-activate-${m.id}`}>Activate</button>
      <button onClick={() => act(`/admin/members/${m.id}/expire`, {})} className="h-9 px-3 rounded-lg bg-red-50 text-[var(--sell)] text-sm font-semibold" data-testid={`admin-member-expire-${m.id}`}>Expire now</button>
    </div>
  );
}

export default function AdminMembers({ auth, onChange }) {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [query, setQuery] = useState("");
  const load = useCallback(() => {
    http.get("/admin/members", { params: { q: query || undefined }, ...auth() }).then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, [query, auth]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="admin-members">
      <form onSubmit={(e) => { e.preventDefault(); setQuery(q.trim()); }} className="flex gap-2">
        <input className="field" placeholder="Search name or mobile..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-member-search-input" />
        <button className="h-12 px-4 rounded-lg bg-[var(--navy)] text-white" data-testid="admin-member-search-button"><Search className="w-5 h-5" /></button>
      </form>
      <div className="mt-4 bg-white rounded-xl border border-slate-200 divide-y">
        {data?.items.map((m) => <MemberRow key={m.id} m={m} auth={auth} reload={() => { load(); onChange?.(); }} />)}
        {data && data.items.length === 0 && <p className="p-6 text-center text-slate-500">No members</p>}
      </div>
    </div>
  );
}
